<div>
	{{ long }}&deg; E {{ lat }}&deg; N
	<span *ngIf=height>{{height}}m</span>
</div>

